import { VlaioZipCodeEntity, VlaioZipCodeResultEntity } from '../interfaces';

export const ZipCodeEntityMock: VlaioZipCodeEntity = {
	label: 'Ghent',
	zip: 9000,
	fusion: true,
	id: 'Ghent9000'
};

export const ZipCodeResultEntityMock: VlaioZipCodeResultEntity = {
	postcode: 9000,
	label: 'Ghent',
	is_fusiegemeente: true,
	niscode: null
};
